module.exports = __webpack_public_path__ + "img/logo_footer.ab0e107c.png";